module.exports = __webpack_public_path__ + "img/wechatpay.61134a3b.png";